(function () {
  function parallax() {
    const items = document.querySelectorAll<HTMLImageElement>(
      '.fc-elegant-three-col-centre-parallax__image'
    );
    items.forEach((img) => {
      const wrap = img.closest('.fc-elegant-three-col-centre-parallax__image-wrap');
      if (!wrap) return;
      const rect = wrap.getBoundingClientRect();
      const winH = window.innerHeight;
      if (rect.bottom < 0 || rect.top > winH) return;
      const scrollPercent = (rect.top + rect.height) / (winH + rect.height);
      img.style.transform = `translateY(${(scrollPercent - 0.5) * -20}%)`;
    });
  }
  window.addEventListener('scroll', parallax, { passive: true });
  parallax();
})();
